import React from 'react'
import { Theme, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

import Earth from '../../../../../icons/Earth'
import { IPostElementProps } from '../../../../../types/types'

const FBSubHeadline: React.FC<IPostElementProps> = (props) => {
  const useStyles = makeStyles((theme: Theme) => ({
    root: {
      display: 'block',
      color: theme.palette.primary.main,
      padding: '0 0 20px',
      marginTop: '-10px'
    },
  }))
  const classes = useStyles()
  const value = props.value

  return (
    <>
      {props.value && (
        <Typography variant='body2' className={classes.root}>
          <>{value} · <Earth width='12px' /></>
        </Typography>
      )}
    </>
  )
}

export default FBSubHeadline
